(function () {
  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }
  function qsa(sel, root) {
    return Array.from((root || document).querySelectorAll(sel));
  }

  /* Each bundle bar carries the variant id it buys and the quantity that
     variant represents. Keep the hidden form fields in step with the selection
     so add-to-cart charges the price the bar shows. */
  function syncBundles() {
    qsa(".souve-bundles .kaching-bundles__bar").forEach(function (bar) {
      var input = bar.querySelector('input[type="radio"]');
      if (!input) return;
      bar.classList.toggle("kaching-bundles__bar--selected", input.checked);
      if (!input.checked) return;
      var qty = qs("[data-souve-qty]");
      if (qty) qty.value = input.getAttribute("data-qty") || "1";
      var variant = input.value;
      var idField = qs('[data-souve-product-form] input[name="id"]');
      if (idField && variant) idField.value = variant;
    });
  }

  document.addEventListener("change", function (e) {
    if (e.target && e.target.matches && e.target.matches('.souve-bundles input[type="radio"]')) {
      syncBundles();
    }
  });

  document.addEventListener("click", function (e) {
    var thumb = e.target.closest && e.target.closest("[data-souve-gallery] button[data-src]");
    if (thumb) {
      var main = qs("#SouveGalleryMain");
      if (main) {
        main.src = thumb.getAttribute("data-src");
        qsa("[data-souve-gallery] button").forEach(function (b) {
          b.classList.toggle("is-active", b === thumb);
        });
      }
    }
    if (e.target.closest && e.target.closest("[data-souve-sticky-atc]")) {
      var form = qs("[data-souve-product-form]");
      if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
    }
  });

  /* The theme renders its own Kaching-styled bars; the app renders its own once
     a bundle is configured for the product. Whichever the app produces wins, so
     the two never appear together. */
  function yieldToApp() {
    var ours = qs("[data-souve-bundles]");
    if (!ours) return;
    var appBar = document.querySelector(".kaching-bundles:not(.souve-bundles) .kaching-bundles__bar");
    if (appBar) ours.classList.add("is-app-active");
  }

  function updateSticky() {
    var sticky = qs("[data-souve-sticky]");
    var buy = qs(".souve-buy__atc");
    if (!sticky || !buy) return;
    var rect = buy.getBoundingClientRect();
    var show = rect.bottom < 0;
    sticky.hidden = false;
    sticky.classList.toggle("is-visible", show);
  }

  // Review carousel: scroll-snap does the work, buttons just move the track.
  function wireCarousels() {
    qsa("[data-souve-carousel]").forEach(function (viewport) {
      var section = viewport.closest(".souve-reviews") || document;
      var prev = qs("[data-souve-carousel-prev]", section);
      var next = qs("[data-souve-carousel-next]", section);
      if (!prev && !next) return;
      function step() {
        var card = viewport.querySelector(".souve-review");
        if (!card) return viewport.clientWidth;
        var gap = parseFloat(getComputedStyle(viewport.querySelector(".souve-reviews__track")).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }
      function go(dir) {
        viewport.scrollBy({ left: dir * step(), behavior: "smooth" });
      }
      if (prev) prev.addEventListener("click", function () { go(-1); });
      if (next) next.addEventListener("click", function () { go(1); });
    });
  }

  /* Disclosures — the FAQ card and the buy-box accordion. The reference does not
     use <details>: the answer sits behind a max-height + padding transition, and
     the plus glyph rotates 45° into an ×. One panel open per group. */
  function wireAccordions() {
    qsa("[data-souve-accordion]").forEach(function (root) {
      var items = qsa("[data-souve-accordion-item]", root);
      items.forEach(function (item) {
        var btn = qs("[data-souve-accordion-trigger]", item);
        var panel = qs("[data-souve-accordion-panel]", item);
        if (!btn || !panel) return;
        btn.addEventListener("click", function () {
          var wasOpen = item.classList.contains("is-open");
          items.forEach(function (other) {
            other.classList.remove("is-open");
            var ob = qs("[data-souve-accordion-trigger]", other);
            var op = qs("[data-souve-accordion-panel]", other);
            if (ob) ob.setAttribute("aria-expanded", "false");
            if (op) {
              if (op.style.maxHeight === "none") {
                op.style.maxHeight = op.scrollHeight + "px";
                void op.offsetHeight;
              }
              op.style.maxHeight = "";
              op.setAttribute("aria-hidden", "true");
            }
          });
          if (wasOpen) return;
          item.classList.add("is-open");
          btn.setAttribute("aria-expanded", "true");
          panel.setAttribute("aria-hidden", "false");
          /* Animate to the measured height, then release the cap entirely.
             Measuring once clipped any answer whose text reflowed after the
             click — a late webfont, a rewrapped line, an image settling — which
             is why long FAQ answers cut off mid-sentence. */
          panel.style.maxHeight = panel.scrollHeight + "px";
          var release = function (e) {
            if (e && e.propertyName && e.propertyName !== "max-height") return;
            if (item.classList.contains("is-open")) panel.style.maxHeight = "none";
            panel.removeEventListener("transitionend", release);
          };
          panel.addEventListener("transitionend", release);
          window.setTimeout(release, 500);
        });
      });
    });
  }

  /* Scroll reveal — the base theme's `.scroll-trigger` system, which the
     reference's section wrappers carry. Each wrapper starts at opacity .01
     (see .js .scroll-trigger.animate--fade-in in souve-pdp.css) and hands over
     to a 0.6s fade the moment it enters the viewport. Revealed once, never
     re-hidden, so scrolling back up does not blank the page. */
  function wireReveal() {
    var targets = qsa(".scroll-trigger.scroll-trigger--offscreen");
    if (!targets.length) return;
    if (!("IntersectionObserver" in window)) {
      targets.forEach(function (el) { el.classList.remove("scroll-trigger--offscreen"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.remove("scroll-trigger--offscreen");
        io.unobserve(entry.target);
      });
    }, { rootMargin: "0px 0px -10% 0px" });
    targets.forEach(function (el) { io.observe(el); });
  }

  document.addEventListener("DOMContentLoaded", function () {
    syncBundles();
    yieldToApp();
    wireCarousels();
    wireAccordions();
    wireReveal();
    updateSticky();
    window.addEventListener("scroll", updateSticky, { passive: true });
  });
})();
